import { inject, Inject, Injectable } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, InteractionRequiredAuthError, PopupRequest} from '@azure/msal-browser';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  authService = inject(MsalService)
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
  ) {}

  ngOnInit(){
  }

  async getAccessToken(scopes: string[]): Promise<string | null> {
    const account = this.authService.instance.getActiveAccount();
    if (!account) {
      console.warn('No active account! Call login first.');
      return null;
    }

    const silentRequest = {
      scopes,                   // e.g. ['api://your-api/.default']
      account,                  // mandatory for acquireTokenSilent
    };

    try {
      // Attempt 1: silent (cache or refresh token or iframe SSO)
      const silentResponse = await lastValueFrom(
        this.authService.acquireTokenSilent(silentRequest)
      );
      return silentResponse.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        // Fallback: interactive (popup or redirect)
        try {
          const interactiveResponse = await lastValueFrom(
            this.authService.acquireTokenPopup({
              ...silentRequest,
              // prompt: 'select_account' if you want to force account picker, etc.
            })
          );
          return interactiveResponse.accessToken;
        } catch (popupError) {
          console.error('Interactive fallback failed', popupError);
          await lastValueFrom(this.authService.acquireTokenRedirect(silentRequest));
          return null;
        }
      }
      console.error('Silent token acquisition failed', error);
      return null;
    }
  }

  login() {
    if (this.msalGuardConfig.authRequest){
      this.authService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest)
        .subscribe((response: AuthenticationResult) => {
          console.log("Guard Config Auth Request Present", response)
          this.authService.instance.setActiveAccount(response.account);
        });
    } else {
        this.authService.loginPopup()
          .subscribe((response: AuthenticationResult) => {
            console.log("No Guard Config Auth Request", response)
            this.authService.instance.setActiveAccount(response.account);
      });
    }
  }

  // Method to log user off - popup
  logout(){
    this.authService.logoutPopup({
      mainWindowRedirectUri: "/"
    });
  }

  // Method to check if user is logged in
  isLoggedIn() : boolean {
      // We simple check the service if the account is active
      return this.authService.instance.getActiveAccount() != null
  }
}
